<!-- Banner visibile solo se isVisible -->

<div *ngIf="false && isVisible" class="cookie-banner">
    <p>
        Utilizziamo i cookie per migliorare l’esperienza utente. Accetti l’uso dei cookie?
        <a href="/privacy-policy" target="_blank">Leggi di più</a>
    </p>
    <button (click)="acceptCookies()">Accetta</button>
    <button (click)="denyCookies()">Rifiuta</button>
</div>

<!-- Linguetta impostazioni -->
<div *ngIf="false && showSettingsToggle" class="cookie-toggle" (click)="resetConsent()">
    ⚙️ Impostazioni cookie
</div>
